import PropTypes from 'prop-types';
import React from 'react';
import { EmptyInteractions } from './EmptyInteractions';
import { StructuredInteractionCard } from './StructuredInteractionCard';

export function StructuredInteractionsList({ interactions }) {
  if (!interactions.length) {
    return <EmptyInteractions />;
  }

  return (
    <div>
      {interactions.map((interaction) => (
        <StructuredInteractionCard
          key={interaction.id}
          interaction={interaction}
        />
      ))}
    </div>
  );
}

StructuredInteractionsList.propTypes = {
  interactions: PropTypes.arrayOf(PropTypes.object),
};

StructuredInteractionsList.defaultProps = {
  interactions: [],
};
